import '../styles/kanzlei.css';
import '../styles/kanzlei-shell.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import type { Me } from '../types';
import { AbrechnungPage } from './abrechnung/AbrechnungPage';
import { MandantDetail } from './accounts/MandantDetail';
import { MandantenList } from './accounts/MandantenList';
import { RegistrationReview } from './accounts/RegistrationReview';
import { TeamPage } from './accounts/TeamPage';
import { OffeneAnfragen } from './anfragen/OffeneAnfragen';
import { BuchenPage } from './buchen/BuchenPage';
import { KanzleiContext } from './context';
import { Home } from './Home';
import { IdleLogout } from './IdleLogout';
import { KanzleiLayout } from './KanzleiLayout';
import { Posteingang } from './posteingang/Posteingang';
import { Postausgang } from './postausgang/Postausgang';
import { Zugriffsprotokoll } from './protokoll/Zugriffsprotokoll';

// Kanzlei-Dashboard für Admin und Mitarbeiter.
export function KanzleiApp({ me }: { me: Me }) {
  return (
    <KanzleiContext.Provider value={{ me }}>
      <IdleLogout />
      <KanzleiLayout>
        <Routes>
          <Route index element={<Home />} />
          <Route path="mandanten" element={<MandantenList />} />
          <Route path="mandanten/:id" element={<MandantDetail />} />
          <Route path="mandanten/:id/:tab" element={<MandantDetail />} />
          <Route path="mandanten/:id/buchen/:jahr/:monat" element={<BuchenPage />} />
          <Route path="registrierungen/:id" element={<RegistrationReview />} />
          <Route path="anfragen" element={<OffeneAnfragen />} />
          <Route path="posteingang" element={me.user.isAdmin ? <Posteingang /> : <Navigate to="/kanzlei" replace />} />
          <Route path="postausgang" element={me.user.isAdmin ? <Postausgang /> : <Navigate to="/kanzlei" replace />} />
          <Route path="abrechnung" element={me.user.isAdmin ? <AbrechnungPage /> : <Navigate to="/kanzlei" replace />} />
          <Route path="team" element={me.user.isAdmin ? <TeamPage /> : <Navigate to="/kanzlei" replace />} />
          <Route path="protokoll" element={me.user.isAdmin ? <Zugriffsprotokoll /> : <Navigate to="/kanzlei" replace />} />
          <Route path="*" element={<Navigate to="/kanzlei" replace />} />
        </Routes>
      </KanzleiLayout>
    </KanzleiContext.Provider>
  );
}
